import { Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgIf } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

interface IconProvider {
	icon(params: ICellRendererParams<unknown, unknown>): IconConfig | undefined;
	onClick(params: ICellRendererParams<unknown, unknown>): (() => void) | undefined;
}

interface IconConfig {
	className?: string;
	iconName?: string;
	toolTipText?: string;
	displayEmpty?: boolean;
}

@Component({
	selector: 'copo-icon-cell',
	templateUrl: './icon-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, NgClass, MatIconModule, MatProgressSpinnerModule, MatTooltipModule]
})
export class IconCellComponent implements ICellRendererAngularComp {
	iconConfig: IconConfig | undefined;
	onClick: (() => void) | undefined;

	constructor(readonly changeDetectorRef: ChangeDetectorRef) {}

	agInit(params: ICellRendererParams<unknown, unknown>) {
		this.changeDetectorRef.markForCheck();
		if (!params.colDef) {
			return;
		}
		const iconProvider = <IconProvider>params.colDef.cellRendererParams;
		this.iconConfig = iconProvider.icon(params);
		this.onClick = iconProvider.onClick(params);
	}

	refresh(params: ICellRendererParams<unknown, unknown>) {
		this.agInit(params);
		return true;
	}

	isClickable() {
		return this.onClick !== undefined;
	}

	evtClick() {
		if (!this.onClick) {
			return;
		}
		this.onClick();
	}
}
